function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 20.75h-1.3a3.2 3.2 0 01-3.2-3.2 4.8 4.8 0 014.8-4.8h4.4a4.8 4.8 0 014.8 4.8 3.2 3.2 0 01-3.2 3.2h-1.3m6.5 0h2.8a3.2 3.2 0 003.2-3.2 4.8 4.8 0 00-4.8-4.8h-1.2m-2-4a4 4 0 000-8m-3 4a4 4 0 11-8 0 4 4 0 018 0z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    stroke: "#2F384C"
  }, props), _ref);
};

export default SvgReferral;